import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { FunctionSetting } from "@/model/FunctionSetting";

const initialState: FunctionSetting = {
    groupCd: null,
    shatenCd: null,
    kyotenCd: null,
    isCanQuickMitsumori: null,
    isCanJizenMitsumori: null,
    /** 2023-10-19 invoice [START] */
    isExcludingTax: null,
    /** 2023-10-19 invoice [END] */
    isDebug: null
    /** 2023-01-26 sh #8180(BQR1080) add course change. [START] */
    , isCanChangeCourse: null
    /** 2023-01-26 sh #8180(BQR1080) add course change. [END] */
};

const actions: ActionTree<FunctionSetting, any> = {
  setState(
    { commit }: ActionContext<FunctionSetting, any>,
    payload: FunctionSetting
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<FunctionSetting, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: FunctionSetting, payload: FunctionSetting) {
    Object.assign(state, payload);
  },
  clearState(state: FunctionSetting) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<FunctionSetting, any> = {
  currentState(state: FunctionSetting): any {
    return state;
  },
  /** 2021-07-30 sh #6989 implements quick mitsumori(priority 2). [START] */
  isCanQuickMitsumori(state: FunctionSetting): any {
    return (state && state.isCanQuickMitsumori == 1);
  },
  /** 2021-07-30 sh #6989 implements quick mitsumori(priority 2). [END] */
  /** 2021-08-19 sh #7350 add isCanJizenMitsumori. [START] */
  isCanJizenMitsumori(state: FunctionSetting): any {
    return (state && state.isCanJizenMitsumori == 1);
  },
  /** 2021-08-19 sh #7350 add isCanJizenMitsumori. [END] */

  /** 2023-10-19 invoice [START] */
  isExcludingTax(state: FunctionSetting): any {
    return (state && state.isExcludingTax == 1);
  },

  taxLabel(state: FunctionSetting): string {
    if(state){
      return state.isExcludingTax == 1 ? '税抜':'税込';
    }else{
      return "";
    }
  },
  /** 2023-10-19 invoice [END] */

  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  isValid(state: FunctionSetting): boolean {
    if (state && state.groupCd != null && state.shatenCd != null && state.kyotenCd != null) {
        return true;
    }
    return false;
  }
  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  /** 2023-01-26 sh #8180(BQR1080) add course change. [START] */
  , isCanChangeCourse(state: FunctionSetting): any {
    return (state && state.isCanChangeCourse == 1);
  },
  /** 2023-01-26 sh #8180(BQR1080) add course change. [END] */
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
